export enum EvmChain {
  Ethereum = "ethereum",
  Polygon = "polygon",
  Avalanche = "avalanche",
  BNBChain = "bnbChain",
  Moonbeam = "moonbeam",
  Fantom = "fantom",
}
